import { Shield, CheckCircle, Package, DollarSign, Truck, Headphones } from 'lucide-react';

const badges = [
  {
    icon: Shield,
    title: 'Secure Payments',
    color: 'text-green-500',
  },
  {
    icon: CheckCircle,
    title: 'Verified Checkout',
    color: 'text-blue-500',
  },
  {
    icon: DollarSign,
    title: 'Customs & Taxes Included',
    color: 'text-orange-500',
  },
  {
    icon: Package,
    title: 'Fair Final Pricing',
    color: 'text-purple-500',
  },
  {
    icon: Truck,
    title: 'Delivery Tracking',
    color: 'text-cyan-500',
  },
  {
    icon: Headphones,
    title: 'Support Guaranteed',
    subtitle: '+1 246 427 3323',
    color: 'text-pink-500',
  },
];

export function TrustBadges({ variant = 'default', className = '' }) {
  if (variant === 'compact') {
    return (
      <div className={`flex flex-wrap justify-center gap-3 ${className}`}>
        {badges.slice(0, 4).map((badge) => (
          <div
            key={badge.title}
            className="flex items-center gap-1.5 text-xs text-slate-500"
          >
            <badge.icon className={`h-3.5 w-3.5 ${badge.color}`} />
            <span>{badge.title}</span>
          </div>
        ))}
      </div>
    );
  }

  if (variant === 'checkout') {
    return (
      <div className={`bg-slate-50 rounded-lg p-4 ${className}`}>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
          {badges.slice(0, 6).map((badge) => (
            <div
              key={badge.title}
              className="flex items-center gap-2 text-sm"
            >
              <div className={`p-1.5 rounded-full bg-white shadow-sm ${badge.color}`}>
                <badge.icon className="h-4 w-4" />
              </div>
              <span className="text-slate-700 text-xs font-medium">{badge.title}</span>
            </div>
          ))}
        </div>
      </div>
    );
  }

  // Default - Hero variant
  return (
    <div className={`${className}`}>
      <div className="flex flex-wrap justify-center gap-4 md:gap-6">
        {badges.map((badge) => (
          <div
            key={badge.title}
            className="flex items-center gap-2 bg-white/80 backdrop-blur-sm px-3 py-2 rounded-full shadow-sm border border-slate-100"
          >
            <div className={`p-1.5 rounded-full bg-slate-50 ${badge.color}`}>
              <badge.icon className="h-4 w-4" />
            </div>
            <div className="text-left">
              <span className="text-slate-800 text-xs font-medium block">{badge.title}</span>
              {badge.subtitle && (
                <span className="text-slate-500 text-[10px]">{badge.subtitle}</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function TrustBadgesMinimal({ className = '' }) {
  const miniBadges = [
    { icon: Shield, text: 'Secure' },
    { icon: CheckCircle, text: 'Verified' },
    { icon: DollarSign, text: 'All-inclusive' },
    { icon: Truck, text: 'Tracked' },
  ];

  return (
    <div className={`flex items-center justify-center gap-4 ${className}`}>
      {miniBadges.map((badge) => (
        <div key={badge.text} className="flex items-center gap-1 text-slate-500 text-xs">
          <badge.icon className="h-3 w-3 text-green-500" />
          <span>{badge.text}</span>
        </div>
      ))}
    </div>
  );
}

export default TrustBadges;
